import LayoutActividad from "../../../components/LayoutActividad";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad1Actividad2.mp3";

const Actividad3 = () => {
  const infoUnidad = modulo14.content[0];
  const infoAct = modulo14.content[0].activities[1];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo14.content[0].name}: ${modulo14.content[0].activities[2].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[2].path}`,
    titlePrev: `${modulo14.content[0].name}: ${modulo14.content[0].activities[0].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[0].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      {" "}
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>
      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              Completa la siguiente información a partir de lo que observas en
              el mapa de la actividad anterior.
            </li>
          </ul>
          <div className="my-4 ps-4">
            <p>
              1. Aproximadamente, ¿cuántas lenguas originarias se hablan en el
              Perú?
            </p>
            <textarea className="form-control"></textarea>
          </div>
          <div className="my-4 ps-4">
            <p>2. ¿En qué departamentos se habla aimara?</p>
            <textarea rows="5" className="form-control"></textarea>
          </div>
          <div className="my-4 ps-4">
            <p>
              3. ¿Cuál es la lengua originaria que se habla en más departamentos
              del Perú?
            </p>
            <textarea className="form-control"></textarea>
          </div>
          <div className="my-4 ps-4">
            <p>
              4. ¿Habías oído hablar de alguna de estas lenguas? ¿De cuál o
              cuáles?
            </p>
            <textarea rows="5" className="form-control"></textarea>
          </div>
          <div className="my-4 ps-4">
            <p>
              5. ¿En qué región del Perú hay mayor diversidad de lenguas: la
              costa, la sierra o la selva?
            </p>
            <textarea className="form-control"></textarea>
          </div>
        </div>
      </div>
      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Completa la siguiente información a
            partir de lo que observas en el mapa.
          </li>
          <li>
            Pida a un o una estudiante que lea en voz alta las preguntas.
            Asegúrese de que las han comprendido. Déles un
            tiempo para que las respondan.
          </li>
          <li>
            Retome de manera oral las respuestas a cada una
            de las preguntas. Pídales que, con un lápiz de otro color, corrijan
            sus respuestas:
            <ol>
              <li>
                Aproximadamente, ¿cuántas lenguas originarias se hablan en el
                Perú?{" "}
                <i>
                  Posible respuesta: Aproximadamente, son 47 lenguas originarias
                  las que se hablan en el Perú.
                </i>
              </li>
              <li>
                ¿En qué departamentos se habla aimara?{" "}
                <i>
                  Posible respuesta: La lengua aimara se habla en 6
                  departamentos: Lima, Moquegua, Tacna, Puno, Cuzco y Madre de
                  Dios. Puede comentar que usamos en castellano palabras de
                  origen aimara, como “alpaca”.
                </i>
              </li>
              <li>
                ¿Cuál es la lengua originaria que se habla en más departamentos
                del Perú?{" "}
                <i>
                  Posible respuesta: El quechua. Puede comentar al respecto lo
                  siguiente: Como vemos en el mapa, el quechua se habla
                  principalmente en zonas andinas, aunque también hay hablantes
                  de quechua en algunos lugares costeños y selváticos.
                </i>
              </li>
              <li>
                ¿Habías oído hablar de alguna de estas lenguas? ¿De cuál o
                cuáles?{" "}
                <i>
                  Respuesta libre. Puede complementar las respuestas preguntando dónde escucharon esa(s) lengua(s) y a
                  quién(es) se la(s) escucharon hablar.
                </i>
              </li>
              <li>
                ¿En qué región del Perú hay mayor diversidad de lenguas: la
                costa, la sierra o la selva?{" "}
                <i>
                  Posible respuesta: En la selva. Puede comentar al respecto que
                  Loreto es el departamento que cuenta con la mayor variedad de
                  lenguas amazónicas, seguido por Ucayali y Madre de Dios.
                </i>
              </li>
            </ol>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
